/* eslint-disable @typescript-eslint/no-use-before-define */
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import csrAccountUpdateAPI from 'services/csrAccountUpdate'
import { ServerError } from 'typings/serverError'
import CSRAccountUpdate from './typings'

export const initState: CSRAccountUpdate = {
  isIncreaseCreditSuccess: false,
  isRequestStatementSuccess: false,
  isResponseFail: false,
  errorMessage: ''
}

export const updateCSRAccount = createAsyncThunk(
  'csrNotificationSlice/updateCSRAccount',
  async (payload: CSRAccountUpdate, { dispatch }) => {
    try {
      const { type } = payload
      const responseStatusCode =
        await csrAccountUpdateAPI.updateIncreaseCreditLine(payload)

      let responseStatus: CSRAccountUpdate = {
        isRequestStatementSuccess: false,
        isIncreaseCreditSuccess: false,
        isResponseFail: false,
        errorMessage: ''
      }

      if (responseStatusCode === 204) {
        switch (type) {
          case 'CREDIT_LINE':
            responseStatus = {
              ...responseStatus,
              isIncreaseCreditSuccess: true
            }
            break
          case 'STATEMENT':
            responseStatus = {
              ...responseStatus,
              isRequestStatementSuccess: true
            }
            break
          default:
        }
      } else {
        responseStatus = {
          ...responseStatus,
          isResponseFail: true
        }
      }

      dispatch(updateCSRAccountState(responseStatus))
    } catch (errorResponse) {
      const { response } = errorResponse as ServerError
      const { message } = response || {}

      dispatch(
        updateCSRAccountState({
          isRequestStatementSuccess: false,
          isIncreaseCreditSuccess: false,
          isResponseFail: true,
          errorMessage: message
        })
      )
    }
  }
)

const csrNotificationSlice = createSlice({
  name: 'csrNotificationSlice',
  initialState: initState,
  reducers: {
    updateCSRAccountState: (
      state: CSRAccountUpdate,
      action: PayloadAction<CSRAccountUpdate>
    ) => {
      return {
        ...state,
        ...action.payload
      }
    }
  }
})

export const { updateCSRAccountState } = csrNotificationSlice.actions

export default csrNotificationSlice.reducer
